import { render } from "./AuthorizedForm.vue?vue&type=template&id=2ca5bd9a"
import script from "./AuthorizedForm.vue?vue&type=script&lang=js"
export * from "./AuthorizedForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__